import { render, staticRenderFns } from "./DoctorsSearch.vue?vue&type=template&id=ca43c084&scoped=true&"
import script from "./DoctorsSearch.vue?vue&type=script&lang=js&"
export * from "./DoctorsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca43c084",
  null
  
)

export default component.exports